<template>
    <div class="applicant-card g-rela">
      <div class="avatar-box g-flex g-row-center" @click="goDetail(item.id)">
        <img :src="item.avatar?item.avatar:$store.state.defaultAvatar" class="avatar" alt="">
      </div>
      <div class="status-bar g-row-center g-flex g-nowrap g-font-10" @click="goDetail(item.id)">{{item.workStatusName}}</div>
      <div class="g-p-t-70  g-text-center">
        <div class="g-p-18" @click="goDetail(item.id)">
          <p class="g-font-20 main-text g-font-weight-6">{{item.name}}</p>
          <div class="g-flex g-m-t-10 g-row-center g-font-14 tag">
            <p>{{item.education}}</p>
            <p class="g-p-l-10 g-p-r-10">|</p>
            <p>{{item.workYear}}经验</p>
            <p class="g-p-l-10 g-p-r-10">|</p>
            <p>{{item.salary}}</p>
          </div>
          <div class="g-m-t-20 g-show-2-line main-text">
            {{item.profile}}
          </div>
        
        </div>
       
      </div>

     
    </div>
</template>

<script>

export default {
  name: "applicant-card-home",
   props:[
	   'item',
	],
  data(){
    return{

    }
  },
  computed: {
  	getUserRole() {
  		return this.$store.state.userInfo.role_name
  	}
  },
  methods:{
    // 收藏
    doCollect(){
      this.$refs.popup2.open();
    },
    // 邀请面试
    doInvite() {
      this.$refs.popup.open()
    },

  //  关闭弹窗提示
    doClose(){
      this.$refs.popup2.close();
    },
	closeInvitePop(){
		 this.$refs.popup.close()
	},
  //  跳转到详情页
    goDetail(id){
		if(!this.$store.state.isLogin||!this.$store.state.userInfo.clinic_id||this.$store.state.userInfo.clinic_id==-1){
			//未登录或非机构用户不能进入人才库页面
			return false;
		}
      this.$router.push({
        path: 'career-detail',
		query:{
			id:id
		}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .applicant-card{
      width: 285px;
      height: 252px;
      background: #fff;
      border-radius: 5px;
      box-shadow: 0 0 10px 0 rgba(64,122,255,0.10);

      .avatar-box{
        background: #f6f6f8;
        border-radius: 50%;
        width: 101px;
        height: 101px;
        position: absolute;
        left: 32%;
        top: -40px;

        .avatar{
          width: 85px;
          height: 85px;
          border-radius: 50%;
          background: #333;
          display: block;
        }
      }

      .status-bar{
        position: absolute;
        left: 0;
        background: #eea906;
        border-radius: 0 15px 15px 0;
        color: #fff;
        padding: 3px 9px;
        top: 50px;
      }

      .tag{
        color: #414A60;
      }

      .line{
        width: 100%;
        height: 1px;
        background: #dddddd;
      }

      .blue-line{
        height: 3px;
        background: #1788ff;
        width: 14%;
        margin-left: 43%;
        margin-top: -3px;
      }
    }

    .cancel-btn{
      padding: 5px 30px;
    }

    .submit-btn{
      padding: 5px 16px;
    }
</style>